import { useState } from 'react'
import ctLogo from 'shared/assets/images/CTLogoBlack.svg'
import { TextV2 } from 'shared/components/Text/TextV2'
import { TYPOGRAPHY } from 'shared/theme/typographyV2'

export interface CompanyBranding {
  id: string
  name: string
  logoUrl: string | null
  sidebarLogoUrl?: string | null
}

export function CompanyBrand({ branding }: { branding?: CompanyBranding }) {
  const [failedImage, setFailedImage] = useState('')
  const logo = branding?.logoUrl || (!branding ? ctLogo : '')
  return (
    <div
      className="flex min-w-0 shrink-0 flex-col justify-center gap-1"
      aria-label={branding?.name || 'CloudTrucks'}
    >
      {logo && failedImage !== logo ? (
        <img
          src={logo}
          alt={`${branding?.name || 'CloudTrucks'} logo`}
          onError={() => setFailedImage(logo)}
          className="h-8 max-w-40 object-contain object-left"
        />
      ) : (
        <TextV2 type={TYPOGRAPHY.label1} className="xs:text-base max-w-56 truncate font-semibold">
          {branding?.name || 'CloudTrucks'}
        </TextV2>
      )}
      {branding && (
        <TextV2 type={TYPOGRAPHY.label3} className="text-mid-gray whitespace-nowrap">
          Powered by CloudTrucks
        </TextV2>
      )}
    </div>
  )
}
